module.exports = __webpack_public_path__ + "img/stand_xiaoman_amused_cut.aeca13f6.png";